module.exports = __webpack_public_path__ + "img/start.2f53bf3c.png";